import { useState } from 'react';

/**
 * ★ VM — nome com lápis: o mesmo editor do PainelContato, agora compartilhado
 * com o painel do lead.
 *
 * Quem decide o que gravar é quem monta (`aoSalvar`): o chat grava
 * `contatoNomeSalvo` na conversa (vazio limpa); a ficha do lead grava
 * `lead.nome` e o nome das conversas vinculadas (vazio é recusado —
 * `permiteVazio: false`). Aqui só mora a interação: abrir com o valor INICIAL
 * (não com o exibido — pré-preencher com o pushName faria um Salvar sem
 * alteração "adotar" aquele nome), salvar, mostrar o erro, Esc/Cancelar fecham.
 */
export default function NomeEditavel({
  nome,
  valorInicial = '',
  aoSalvar,
  rotulo = 'Nome',
  ajuda = null,
  placeholder = '',
  permiteVazio = true,
  titulo = 'Editar o nome',
  id = 'nome-editavel',
}) {
  const [editando, setEditando] = useState(false);
  const [rascunho, setRascunho] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState(null);

  function abrir() {
    setRascunho(valorInicial ?? '');
    setErro(null);
    setEditando(true);
  }
  function fechar() {
    setErro(null);
    setEditando(false);
  }
  async function salvar(evento) {
    evento.preventDefault();
    const novo = rascunho.trim();
    if (!permiteVazio && !novo) return;
    setSalvando(true);
    setErro(null);
    try {
      await aoSalvar(novo);
      setEditando(false);
    } catch (e) {
      setErro(e?.message ?? 'Não foi possível salvar o nome.');
    } finally {
      setSalvando(false);
    }
  }

  if (!editando) {
    return (
      <div className="nome-contato">
        <h2>{nome}</h2>
        <button type="button" className="btn-lapis" onClick={abrir} title={titulo} aria-label={titulo}>
          ✎
        </button>
      </div>
    );
  }

  return (
    <form className="form-nome-contato" onSubmit={salvar}>
      <label className="sr-apenas" htmlFor={id}>{rotulo}</label>
      <input
        id={id}
        value={rascunho}
        onChange={(e) => setRascunho(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Escape') { e.stopPropagation(); fechar(); } }}
        placeholder={placeholder}
        maxLength={80}
        autoFocus
      />
      <div className="form-nome-acoes">
        <button type="submit" className="btn-primario compacto" disabled={salvando || (!permiteVazio && !rascunho.trim())}>
          {salvando ? 'Salvando…' : 'Salvar'}
        </button>
        <button type="button" className="btn-texto" onClick={fechar}>
          Cancelar
        </button>
      </div>
      {ajuda && <p className="campo-ajuda">{ajuda}</p>}
      {erro && <p className="erro">{erro}</p>}
    </form>
  );
}
